import React, { FunctionComponent } from 'react';
import {
  FlexAlignType,
  StyleProp,
  StyleSheet,
  Text,
  TextStyle,
  View,
  ViewStyle,
} from 'react-native';
import Theme from '../theme';
import { defaultScale } from '../utils';

interface IProps {
  text: string;
  alignment?: FlexAlignType;
  containerStyle?: StyleProp<ViewStyle>,
  textStyle?: StyleProp<TextStyle>,
}

const Label: FunctionComponent<IProps> = (
  {
    text,
    alignment,
    containerStyle,
    textStyle,
  },
) => (
  <View style={[styles.textContainer, { backgroundColor: Theme.PRIMARY, alignSelf: alignment }, containerStyle]}>
    <Text style={[styles.text, textStyle]}>{text}</Text>
  </View>
);

const styles = StyleSheet.create({
  textContainer: {
    borderRadius: defaultScale(3),
    paddingVertical: defaultScale(4),
    paddingHorizontal: defaultScale(6),
  },
  text: {
    ...Theme.textStyle.smallBold,
    color: Theme.WHITE,
    textTransform: 'uppercase',
  },
});

export default Label;
